import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";
import {
  UpdateUserRoleRequest,
  UserForSharingCampaign,
  UserThatShareCampaign,
} from "../types/apiTypes";
import { RequestMethods } from "../types/enums";
import { CampaignId, ListQuery } from "../types";
import { prepareQuery } from "../utils/prepareQuery";

export const shareCampaignApi = createApi({
  reducerPath: "shareCampaignApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["shared-users"],
  endpoints: (builder) => ({
    getUsersForSharing: builder.query<UserForSharingCampaign[], ListQuery>({
      query: ({ campaign_id, ...query }) => ({
        url: `/users/${campaign_id}/for_sharing${prepareQuery(query)}`,
        method: RequestMethods.GET,
      }),
    }),

    getUsersThatShareCampaign: builder.query<UserThatShareCampaign[], string>({
      query: (campaign_id) => ({
        url: `/user-campaigns/${campaign_id}/users`,
        method: RequestMethods.GET,
      }),
      providesTags: ["shared-users"],
    }),

    deleteUserFromCampaign: builder.mutation<
      Response,
      { campaign_id: string; user_email: string }
    >({
      query: ({ campaign_id, user_email }) => ({
        url: `/user-campaigns/${campaign_id}/users?user_email=${user_email}`,
        method: RequestMethods.DELETE,
      }),
    }),

    changeUsersRoleInCampaign: builder.mutation<
      Response,
      UpdateUserRoleRequest
    >({
      query: ({ campaign_id, ...body }) => ({
        url: `/user-campaigns/${campaign_id}/users/roles`,
        method: RequestMethods.PATCH,
        body,
      }),
    }),

    inviteUserToShareCampaign: builder.mutation<
      Response,
      { user_email: string } & CampaignId
    >({
      query: ({ campaign_id, ...body }) => ({
        url: `/user-campaigns/${campaign_id}/users/invite`,
        method: RequestMethods.POST,
        body,
      }),
    }),
  }),
});

export const {
  useGetUsersForSharingQuery,
  useLazyGetUsersThatShareCampaignQuery,
  useDeleteUserFromCampaignMutation,
  useChangeUsersRoleInCampaignMutation,
  useInviteUserToShareCampaignMutation,
} = shareCampaignApi;
